__turbopack_context__.v({
  "className": "teko_c8089e7e-module___KkQwG__className",
});
